import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

let token

try {
  token = localStorage.getItem('token') // userToken
} catch {
  token = null
}

export default {
  token,
  deviceType: ''
}
